export const PRODUCTS_LIST_KEY = 'PRODUCTS_LIST';
export const PRODUCTS_WITH_STOCK_LIST_KEY = 'PRODUCTS_WITH_STOCK_LIST_KEY';
export const RELATED_PRODUCTS_LIST_KEY = 'RELATED_PRODUCTS_LIST_KEY';

export const PRODUCTS_DISEASES_LIST_KEY = 'PRODUCTS_DISEASES_LIST_KEY';
export const PRODUCTS_ALLERGIES_LIST_KEY = 'PRODUCTS_ALLERGIES_LIST_KEY';
export const PRODUCTS_ONE_KEY = 'PRODUCTS_ONE_KEY';
export const STORE_PRODUCTS_ONE_KEY = 'STORE_PRODUCTS_ONE_KEY';
